// desktop arrows to scroll sub nav
let subNav = $('#subnav');
let hasSubNav = subNav.length > 0;

if (hasSubNav) {
    let subNavItems = $('.subnav__items');
    let activeSubnav = $('.subnav__items li a.active');

    function scrollActiveSubnavIntoView() {
        let offset = activeSubnav.offset();
        if (offset) {
            let compensatePageSize = $(window).width() / 2 - activeSubnav.width() / 2;
            subNavItems.scrollLeft(offset.left - compensatePageSize);
        }
    }

    if (!CBS.Registry.platform.isMobile) {
        $(document).ready(function () {
            checkArrowDisplay();
            scrollActiveSubnavIntoView();
        });

        let resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                checkArrowDisplay();
            }, 250);
        });

        function checkArrowDisplay() {
            // subnav edges
            let subnavRect = subNavItems[0].getBoundingClientRect();
            let subnavRightEdge = Math.round(subnavRect.right);
            let subnavLeftEdge = Math.round(subnavRect.left);

            // li list
            let liList = subNavItems.find('li:visible');

            // first li
            let firstItem = liList.first();
            let firstItemRect = firstItem[0].getBoundingClientRect();
            let firstItemLeftEdge = Math.round(firstItemRect.left);

            // last visible li
            let lastItem = liList.last();
            let lastItemRect = lastItem[0].getBoundingClientRect();
            let lastItemRightEdge = Math.round(lastItemRect.right);

            if (firstItemLeftEdge < subnavLeftEdge || lastItemRightEdge > subnavRightEdge) {
                subNav.addClass('has-arrows');
            } else {
                subNav.removeClass('has-arrows');
            }
        }

        let firstSubnavItem = subNavItems[0];
        let visible_width = firstSubnavItem.offsetWidth;
        let full_div_width = firstSubnavItem.scrollWidth;

        subNavItems.scroll(function () {
            visible_width = firstSubnavItem.offsetWidth;
            full_div_width = firstSubnavItem.scrollWidth;

            if (subNavItems.scrollLeft() + visible_width === full_div_width) {
                $('.nav-next').css('opacity', '.35');
            }
            if (subNavItems.scrollLeft() + visible_width < full_div_width) {
                $('.nav-next').css('opacity', '1.0');
            }
            if (subNavItems.scrollLeft() === 0) {
                $('.nav-prev').css('opacity', '.35');
            }
            if (subNavItems.scrollLeft() > 0) {
                $('.nav-prev').css('opacity', '1.0');
            }
        });

        $('.nav-next').click(function () {
            subNavItems.animate(
                {
                    scrollLeft: '+=' + visible_width
                },
                300
            );
        });

        $('.nav-prev').click(function () {
            subNavItems.animate(
                {
                    scrollLeft: '-=' + visible_width
                },
                300
            );
        });
    } else {
        $(document).ready(function () {
            scrollActiveSubnavIntoView();
        });
    }
}
